import { render } from "./QuizForm.vue?vue&type=template&id=5fb411c2&scoped=true"
import script from "./QuizForm.vue?vue&type=script&lang=js"
export * from "./QuizForm.vue?vue&type=script&lang=js"

import "./QuizForm.vue?vue&type=style&index=0&id=5fb411c2&scoped=true&lang=css"

import exportComponent from "/home/runner/work/ipc-app/ipc-app/apps/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fb411c2"]])

export default __exports__